import React from "react";

function DetailLinkedPagination({pageable, onPageChange}) {
    const pageNumber = Number(pageable?.pageNumber ?? 0);
    const totalPages = Math.max(1, Number(pageable?.totalPages ?? 1));
    const totalElements = Number(pageable?.totalElements ?? 0);
    const pageSize = Number(pageable?.pageSize ?? pageable?.size ?? 20);
    const isFirst = pageNumber <= 0;
    const isLast = pageNumber >= totalPages - 1;

    const changePage = (next) => {
        if (!onPageChange || next < 0 || next >= totalPages) return;
        onPageChange({
            ...pageable,
            pageNumber: next,
            pageSize,
            size: pageSize,
        });
    };

    return (
        <div className="asset-linked-grid-pagination">
            <span className="asset-linked-grid-pagination-summary">
                총 <strong>{totalElements.toLocaleString()}</strong>건 ·{" "}
                <strong>{pageNumber + 1}</strong> / {totalPages} 페이지
            </span>
            <div className="asset-linked-grid-pagination-actions">
                <button
                    type="button"
                    className="asset-linked-grid-page-btn"
                    disabled={isFirst}
                    onClick={() => changePage(pageNumber - 1)}
                >
                    이전
                </button>
                <button
                    type="button"
                    className="asset-linked-grid-page-btn"
                    disabled={isLast}
                    onClick={() => changePage(pageNumber + 1)}
                >
                    다음
                </button>
            </div>
        </div>
    );
}

export default DetailLinkedPagination;
